import type { SelectedFile } from '@witmetrics/utils';
import { asyncMap } from '@witmetrics/utils/arrays';
import { API } from '@/api';
import { uploadNoteAttachment } from '@/utils/files';
import { useLocalStorage } from '@/hooks/useStorage';
import type { TimelineItem } from './types';

export const classes = {
  section: 'flex-1 min-h-0 overflow-y-auto',
  message: 'mt-4 text-center text-grey-6 dark:text-mauve-3 text-base',
  toggle: 'mr-4',
  toggleOption: 'py-1',
};

export function useTimelineSettings(initialSettings?: TimelineItem) {
  return useLocalStorage('timelineSettings', initialSettings || 'ALL', true);
}

export async function createOrderNote(
  orderId: number,
  content: string,
  selectedFiles: SelectedFile[]
) {
  const note = await API.Notes.createNewNote({ content });
  const [attachments, orderNote] = await Promise.all([
    uploadAttachmentFiles(note.id, selectedFiles),
    API.Orders.addNoteToOrder(orderId, note.id),
  ]);
  return {
    orderNote,
    attachments,
  };
}

function uploadAttachmentFiles(noteId: number, files: SelectedFile[]) {
  return asyncMap(files, async (selectedFile) => {
    const noteFile = await uploadNoteAttachment(noteId, selectedFile.file);
    return { noteFile, selectedFile };
  });
}
